<template>
	<div id="">
		<!--点播播放器在当前页面-->
		<div class="dianbox">
			<van-icon name="arrow-left" color='#FFF' size='30px' class='closearrow' @click='pausefuc'/>
			<div class="prism-player" id="player-con"></div>
		</div>
	</div>
</template>

<script>
	import { Icon } from 'vant';
	export default {
		components: {
			[Icon.name]:Icon,
		},
		data(){
			return{
				player:{},
			}
			
		},
		methods:{
			pausefuc(){//暂停点播
				this.player.pause();
				this.$router.back();
			},
		},
		mounted(){
			this.player = new Aliplayer({
				"id": "player-con",
				"source": this.$route.query.url,
				"width": "100%",
				"height": "90vh",
				"autoplay": true,
				"isLive": false,
				"rePlay": false,
				"playsinline": true,
				"preload": true,
				"controlBarVisibility": "hover",
				"useH5Prism": true,
				
			}, function(player) {
				console.log("The player is created");
			});
		}
	}
</script>

<style scoped>
	.dianbox{
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 10000;
		background-color: #FFFFFF;
		box-sizing: border-box;
		padding-top: 10vh;
	}
	
	.closearrow{
		position: absolute;
		left: 0%;
		top: 0px;
		z-index: 1000;
		width: 100%;
		height: 10vh;
		background-color: #000000;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		box-sizing: border-box;
		padding-left: 3%;
	}
</style>